import React, { SyntheticEvent, useCallback, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { RadioGroup } from '@atlaskit/radio';
import { OptionType, SelectProps } from '@atlaskit/select';

import { useIntl } from 'src/hooks/intl';
import { DiffViewMode } from 'src/redux/diff-settings';
import { getIsMobileHeaderActive } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

import { useDiffSettingsForm } from './diff-settings-form';
import messages from './i18n';

export const DiffViewModeField = React.memo(
  (props: SelectProps<OptionType>) => {
    const intl = useIntl();
    const isMobileHeaderActive = useSelector<BucketState, boolean>(
      getIsMobileHeaderActive
    );
    const [formState, setFormState] = useDiffSettingsForm();

    const handleRadioGroupChange = useCallback(
      (event: SyntheticEvent<HTMLInputElement>) => {
        const diffViewMode =
          event.currentTarget.value === DiffViewMode.SideBySide
            ? DiffViewMode.SideBySide
            : DiffViewMode.Unified;
        setFormState(state => ({ ...state, diffViewMode }));
      },
      [setFormState]
    );

    const diffViewModeOptions = useMemo(
      () => [
        {
          label: intl.formatMessage(messages.diffViewModeLabelUnified),
          value: DiffViewMode.Unified,
        },
        {
          label: intl.formatMessage(messages.diffViewModeLabelSideBySide),
          value: DiffViewMode.SideBySide,
        },
      ],
      [intl]
    );

    return (
      <RadioGroup
        isDisabled={props.isDisabled || isMobileHeaderActive}
        options={diffViewModeOptions}
        onChange={handleRadioGroupChange}
        name="diffViewMode"
        value={
          diffViewModeOptions.find(
            (option: OptionType) => option.value === formState.diffViewMode
          )?.value
        }
      />
    );
  }
);
